import { FileManagerConfig } from '@/types/fileManager';

/**
 * Default max file size for client-side validation (500MB).
 * Must match the Lambda's FILE_MANAGER_MAX_UPLOAD_BYTES default.
 */
const DEFAULT_MAX_FILE_SIZE = 500 * 1024 * 1024; // 500MB

/**
 * Default configuration for the file manager.
 *
 * Bucket names and paths here are placeholders for the type shape.
 * The Lambda owns all S3 location config — the frontend never sends
 * bucket/path info to S3 or the Lambda. These values are only used
 * for logging context and error messages.
 *
 * Upload and download point to the same location by default.
 * For dual-location mode, set them to different values.
 */
export const DEFAULT_FILE_MANAGER_CONFIG: FileManagerConfig = {
  bucketName: 'lambda-managed',
  basePath: '',
  blockedFileTypes: [
    '.exe',
    '.bat',
    '.cmd',
    '.com',
    '.msi',
    '.scr',
    '.pif',
    '.sh',
    '.bash',
    '.ps1',
    '.vbs',
    '.vbe',
    '.js',
    '.jse',
    '.wsf',
    '.wsh',
    '.dll',
    '.sys',
    '.drv',
    '.cpl',
    '.inf',
    '.reg',
    '.hta',
  ],
  maxFileSize: DEFAULT_MAX_FILE_SIZE,

  upload: {
    bucketName: 'lambda-managed',
    basePath: '',
  },

  download: {
    bucketName: 'lambda-managed',
    basePath: '',
  },

  s3Prefixes: {
    uploadPrefix: 'transfer/upload-staging/',
    activePrefix: 'transfer/active/',
    archivePrefix: 'transfer/pending-archive/',
  },
};

/**
 * Required user permissions for file manager access
 */
export const FILE_MANAGER_PERMISSIONS = {
  REQUIRED_GROUP: 'FileManagerAdmin',
  ALLOWED_GROUPS: ['FileManagerAdmin', 'Admin'] as string[],
} as const;
